import { createRoot } from "react-dom/client";
import App from "./components/App";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { registerServiceWorker } from "./sw-register";
import { installChunkLoadRecovery } from "./utils/chunkLoadRecovery";
import { renderFatalError } from "./utils/fatalErrorScreen";
import "./tailwind.css";
import "./styles/tokens.css";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

// [Table Status Data Mismatch, step 2] dayjs's format-parsing form -- dayjs(str,
// "DD-MM-YYYY HH:mm:ss") -- silently yields Invalid Date unless customParseFormat
// is registered. It was only ever registered as a side effect of importing
// Dashboard2/index.js, so all 16 format-parse call sites (CloseTill, Kiosk,
// Estimate, pricingRuleController) were correct only when that module happened to
// have been loaded first. Registering it at the entry point makes it
// unconditional. dayjs.extend is idempotent, so Dashboard2's own call is harmless.
dayjs.extend(customParseFormat);

window.addEventListener("error", (event) => {
  if (event.error && !document.querySelector("[data-error-boundary]")) {
    console.error("[POS] Uncaught error:", event.error);
    renderFatalError(event.error);
  }
});

try {
  const root = createRoot(document.getElementById("root"));
  root.render(
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  );
} catch (error) {
  console.error("[POS] Fatal startup error:", error);
  renderFatalError(error);
}

installChunkLoadRecovery();
registerServiceWorker();
